import React, { useState } from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import Input from '../../TravellerContactInfo/FormFields/Input';

import '../LoginModals.css';
import { If } from 'react-extras';
import {customStyles, UserFlowModalState} from '../../UserFlow/UserFlowModal';

const UserAccountSuspended = (props: UserFlowModalState) => {
  const [ state, setState ] = useState({
    showModal: props.showModal || false,
    validationFail: false,
  });

  const closeModal = () => {
    setState({
      ...state,
      showModal: false,
    });
    props.closeModal();
  };

  const goToIRCTCRegistrationPage=() => {
    props.createAccount();
  };

  const { userStatus: { userId }, switchModal, allowClose } = props;
  const { showModal, validationFail } = state;

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className="loginModals"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className="makeFlex spaceBetween appendBottom40">
        <span className="modalTitle font26 latoBloack blackText">
            IRCTC Account Suspended
        </span>
        <If condition={allowClose === true}>
          <span
            className="modalClose"
            onClick={closeModal}
          >
            X
          </span>
        </If>
      </p>
      <p className="vrtlSeperater" />
      <div className="makeFlex spaceBetween">
        <div className="leftPanel">
          <p className="font20 latoBold darkGreyText appendBottom10"> User verified but profile incomplete </p>
          <p className="font14 darkGreyText appendBottom40">
            <span className="redText"> Bookings are not allowed</span> by IRCTC with this username.You can change username and try again or create new IRCTC account. Please email care@irctc.co.in for furthur assistance.
          </p>
          <div className={`makeFlex spaceBetween ${validationFail ? 'hrtlCenter' : 'end'}`}>
            <Input
              labelName="IRCTC USERNAME"
              errorMessage={`Username ${userId} doesn’t exist.`}
              validationFail={validationFail}
              type="text"
              additionalAttributes={{ placeholder: userId }}
              fieldId="IRCTCUserName"
              fieldName="IRCTCUserName"
              vaidationMsg="Verified"
              vaidationMoreMsg="Change"
              vaidationMoreStatus={false}
              vaidationStatus
              readOnly
              irctcUserId={userId}
              switchModal={switchModal}
              onChangePage="verifyUsername"
            />
          </div>
          <p className="darkGreyText lineHeight18 font14 appendTop30"> <b>Note:</b> IRCTC Username is case sensitive, has 3-35 <br /> characters of upper and lower case letters , numbers and ‘_’. </p>
        </div>
        <div className="rightPanel">
          <p className="font20 latoBold darkGreyText appendBottom10">Create new account</p>
          <p className="latoBold font14 greenText appendBottom15">and continue from where you left</p>
          <p className="font14 darkGreyText appendBottom50">Just remember that you can not use an email address or mobile number which has already been registered with IRCTC.</p>
          <button
            className=" noShrink width220"
            onClick={goToIRCTCRegistrationPage}
          >
            <span className="font12 latoBlack capText">CREATE NEW ACCOUNT</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default withRouter(UserAccountSuspended);
